import React, { useState, useEffect } from 'react';
import InputSelect from 'components/InputSelect';
import InputSelectMultiple from 'components/InputSelectMultiple';
import { ENUM_STATUS_IS_SETORIAL } from 'utils/consts';

export default function FormAtendenteSetorial({
  errors,
  control,
  handleChange,
  getValues,
  optionsSetores,
  disabled,
  bloquearInputAtendenteSetorial,
  exibirVariosSetores,
}) {
  const optionsSetorial = [
    { value: ENUM_STATUS_IS_SETORIAL.SIM.value, label: ENUM_STATUS_IS_SETORIAL.SIM.label },
    { value: ENUM_STATUS_IS_SETORIAL.NAO.value, label: ENUM_STATUS_IS_SETORIAL.NAO.label },
  ];
  const [exibirComboSetores, setExibirComboSetores] = useState(getValues()?.isSetorial);

  const changeSetorial = value => {
    handleChange({ target: { name: 'setoresIds', value: [value] } });
  };

  useEffect(() => {// eslint-disable-line
    if (getValues()?.isSetorial === 'NAO') setExibirComboSetores(false);
  });

  return (
    <>
      <InputSelect
        label="* Atendente Setorial"
        name="isSetorial"
        errors={errors}
        placeholder={'Atendente Setorial'}
        control={control}
        options={optionsSetorial}
        disabled={disabled || bloquearInputAtendenteSetorial}
        viewChange={e => setExibirComboSetores(e)}
      />
      {exibirVariosSetores &&
        (exibirComboSetores === ENUM_STATUS_IS_SETORIAL.SIM.value || bloquearInputAtendenteSetorial) && (
          <InputSelectMultiple
            label="* Setor"
            name="setoresIds"
            errors={errors}
            placeholder={'Setor do usuário'}
            control={control}
            options={optionsSetores}
            disabled={disabled}
            initialValue={getValues()?.setoresIds || []}
          />
        )}
      {!exibirVariosSetores &&
        (exibirComboSetores === ENUM_STATUS_IS_SETORIAL.SIM.value || bloquearInputAtendenteSetorial) && (
          <InputSelect
            label="* Setor"
            name="setoresIds"
            errors={errors}
            placeholder={'Setor do usuário'}
            control={control}
            options={optionsSetores}
            disabled={disabled}
            viewChange={e => changeSetorial(e)}
          />
        )}
    </>
  );
}
